import Swiper from 'swiper';
import {Pagination,Navigation, A11y, Keyboard, Autoplay} from "swiper/modules";
//import {enable} from "core-js/internals/internal-metadata";

if(document.querySelectorAll('.usp-teaser-slider')) {
    (async function () {
        const sliderElements = document.querySelectorAll('.usp-teaser-slider');

        if (sliderElements.length === 0) {
            return false;
        }

        sliderElements.forEach(slider => {
            const swiper = new Swiper(slider.querySelector('.swiper'), {
                slidesPerView: 'auto',
                spaceBetween: 24,
                modules: [Pagination,Navigation, A11y, Keyboard, Autoplay],
                autoplay: slider.dataset?.autoplay === 'true',
                loop: true,
                keyboard: {
                    enabled: true
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
            swiper.params.autoplay.delay = parseInt(slider.dataset?.interval) || 3000
        });
    })();
}

